exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lead-row-striped:nth-child(odd){--lead-row-background:#f3f4f6}.lead-row-striped:nth-child(2n){--lead-row-background:#fff}.lead-row-striped.new-lead-highlight:nth-child(odd){--lead-row-background:#ffefad}.lead-row-striped.new-lead-highlight:nth-child(2n){--lead-row-background:#fff7cc}.lead-row-striped:nth-child(n),.lead-row-striped:nth-child(n)>td,.report-lead-log>article.lead-entry.lead-row-striped:nth-of-type(n){background-color:var(--lead-row-background)!important}", ""]);

// exports
